import { render, staticRenderFns } from "./EmailLanguageButton.vue?vue&type=template&id=10ed09f6&scoped=true"
import script from "./EmailLanguageButton.vue?vue&type=script&lang=js"
export * from "./EmailLanguageButton.vue?vue&type=script&lang=js"
import style0 from "./EmailLanguageButton.vue?vue&type=style&index=0&id=10ed09f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed09f6",
  null
  
)

export default component.exports